import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var composeReducers = function composeReducers() {
  var initialFn = function initialFn() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  };
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }
  return reducers.reduce(function (result, reducer) {
    return function (state, action) {
      return reducer(result(state, action), action);
    };
  }, initialFn);
};
var ReducerRegistry = /*#__PURE__*/function () {
  function ReducerRegistry() {
    _classCallCheck(this, ReducerRegistry);
    this.reducers = [];
  }
  _createClass(ReducerRegistry, [{
    key: "addReducer",
    value: function addReducer(newReducer) {
      if (this.reducers.indexOf(newReducer) !== -1) {
        console.log('reducer already exists, skipping');
        return;
      }
      this.reducers.push(newReducer);
    }
  }, {
    key: "removeReducer",
    value: function removeReducer(reducer) {
      var index = this.reducers.indexOf(reducer);
      if (index !== -1) {
        this.reducers.splice(index, 1);
      }
    }
  }, {
    key: "getComposedReducer",
    value: function getComposedReducer() {
      return composeReducers.apply(void 0, _toConsumableArray(this.reducers));
    }
  }]);
  return ReducerRegistry;
}();
export default new ReducerRegistry();